// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import  store from "./store"
import axios from 'axios'
import qs from 'qs'
/*import LyTab from 'ly-tab'*/
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueWechatTitle from 'vue-wechat-title';
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
/*axios.default.baseURL="/API"*/

/*Vue.use(LyTab)*/
Vue.use(VueAwesomeSwiper)
Vue.use(VueWechatTitle)
Vue.use(MintUI)

Vue.prototype.$http = axios
Vue.config.productionTip = false


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.baseURL ="https://api.hcmdonline.com" //生产
//axios.defaults.baseURL ="https://testapi.hcmdonline.com" /*测试*/
//axios.defaults.baseURL ="https://uatapi.hcmdonline.com" //预发

/*axios.defaults.baseURL ="https://api.hcmdonline.com"*/

axios.defaults.baseURL = "https://wap.hcmdonline.com"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (store.state.token) {  // 通过vuex state获取当前的token是否存在
      next();
    }
    else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else {
    next();
  }
})




// WEBPACK FOOTER //
// ./src/main.js